import React, { useState, useEffect } from 'react';
import { TextInputTypeV2, TextInputV2 } from '@wajeez-web/components/ui';
import { FieldValues, UseControllerProps } from 'react-hook-form';

import { TextFormType } from '../Types';
import { FormInputController } from '../FormInputController';

export interface FormTextInputV2Props<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    TextInputTypeV2 {
  fieldMeta: TextFormType;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
  readOnly?: boolean;
  onBlur?: () => void;
}

export const FormTextInputV2 = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  readOnly,
  onBlur,
  ...props
}: FormTextInputV2Props<TFormFields>) => {
  const [isReadOnly, setIsReadOnly] = useState(readOnly);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsReadOnly(false);
    }, 650);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({
        onBlur: onControllerBlur,
        onChange: onControllerChange,
        ...controllerProps
      }) => (
        <TextInputV2
          label={fieldMeta.label}
          placeholder={fieldMeta.placeHolder}
          required={fieldMeta.required}
          readOnly={isReadOnly}
          onChange={(...event) => {
            onControllerChange(...event);

            fieldMeta.onChange && fieldMeta.onChange(...event);
          }}
          onBlur={() => {
            onControllerBlur();

            onBlur && onBlur();
          }}
          {...controllerProps}
          {...props}
        />
      )}
      {...props}
    />
  );
};
